(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/team-members/team-email.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/team-members/team-email.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Checkbox = svs.ui.reactForm.Checkbox;
const TextField = svs.arena.pages.teams.components.TextField;
const handleSendEmailAsync = svs.arena.pages.teams.helpers.handleSendEmailAsync;
const TeamEmail = _ref => {
  let teamId = _ref.teamId,
    activeMembers = _ref.activeMembers,
    inactiveMembers = _ref.inactiveMembers,
    _ref$onHide = _ref.onHide,
    onHide = _ref$onHide === void 0 ? () => {} : _ref$onHide;
  const _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isIncludeInactive = _React$useState2[0],
    setIsIncludeInactive = _React$useState2[1];
  const handleSubmit = async message => {
    const track = {
      category: 'spela-tillsammans',
      action: 'all_members_email',
      opt_label: 'send_email'
    };
    svs.components.analytics.trackEvent(track);
    const sendList = activeMembers.filter(m => m.isCurrentMember === false).map(m => m.customerId);
    if (isIncludeInactive) {
      inactiveMembers.forEach(m => {
        sendList.push(m.customerId);
      });
    }
    const res = await handleSendEmailAsync(teamId, sendList, message);
    if (!(res !== null && res !== void 0 && res.error)) {
      onHide();
    }
  };
  const handleClick = e => {
    e.stopPropagation();
    const track = {
      category: 'spela-tillsammans',
      action: 'all_members_email',
      opt_label: isIncludeInactive ? 'only_active_members' : 'include_resting_members'
    };
    svs.components.analytics.trackEvent(track);
    setIsIncludeInactive(!isIncludeInactive);
  };
  const onCancel = () => {
    const track = {
      category: 'spela-tillsammans',
      action: 'all_members_email',
      opt_label: 'cancel_email'
    };
    svs.components.analytics.trackEvent(track);
    onHide();
  };
  return React.createElement(React.Fragment, null, React.createElement(Checkbox, {
    checked: isIncludeInactive,
    className: "margin-top-1",
    onChange: handleClick
  }, "Inkludera vilande medlemmar"), React.createElement(TextField, {
    onCancel: onCancel,
    onHide: onHide,
    onSubmit: handleSubmit
  }));
};
svs.arena.pages.teams.components.TeamEmail = TeamEmail;

 })(window);